var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5C12.5 6.67275 11.8273 6 11 6H10.25V3.75C10.25 1.68225 8.56775 0 6.5 0C4.43225 0 2.75 1.68225 2.75 3.75V6H2C1.17275 6 0.5 6.67275 0.5 7.5V13.5C0.5 14.3273 1.17275 15 2 15H11C11.8273 15 12.5 14.3273 12.5 13.5V7.5ZM4.25 3.75C4.25 2.5095 5.2595 1.5 6.5 1.5C7.7405 1.5 8.75 2.5095 8.75 3.75V6H4.25V3.75Z",
    fill: "#0032FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlue);
export default __webpack_public_path__ + "static/media/lock-blue.423e8a0d.svg";
export { ForwardRef as ReactComponent };